//#region import libraries
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// reduxx
import { useSelector, useDispatch } from 'react-redux'
import { selectTransaction, updateTransaction, resetUpdateTransaction, selectUpdateTransactionStatus } from '_redux/slices/marketplace/transaction'
import { setUser } from '_redux/slices/profile/user-profile'
import { getFirebaseInfo } from '_redux/slices/main-screen/user';

// bootstrap
import { Form, Row, Col, Button } from 'react-bootstrap';

// custom components
import { NewScreen, Title as CustomTitle, CustomSpinner } from '_atoms';

// styling
import { Colors, Spacing } from '_styles';

// icons
import { FaUserCircle } from "react-icons/fa";

// date
import moment from 'moment';
//#endregion

const TransactionInformation = (props) => {

    //nav
    const history = useHistory();

    //#region redux
    const dispatch = useDispatch();
    const transaction = useSelector(selectTransaction);
    const updateTransactionStatus = useSelector(selectUpdateTransactionStatus);
    //#endregion

    //#region states
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [priceString, setPriceString] = useState("");
    const [loadingStatus, setLoadingStatus] = useState(null);
    const [enabledField, setEnabledField] = useState("");
    const [fieldError, setFieldError] = useState("");
    const [isEditingStatus, setIsEditingStatus] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    //#endregion

    const handleChangeField = (status) => {
        if (!status) {
            setFieldError("Status can't be empty");
            return;
        }

        setLoadingStatus(status);
        setFieldError("");

        const updatedTransaction = { ...transaction, status };
        dispatch(updateTransaction(updatedTransaction));
    };


    const showProfile = () => {
        if (transaction && transaction.userId) {
            dispatch(setUser(transaction.userId))
            history.push('/user-profile')
        }
    }

    useEffect(() => {
        if (transaction) {

            console.log('transaction', transaction);

            if (transaction.billingAddress && transaction.billingAddress.name && transaction.billingAddress.name !== '') {
                setName(transaction.billingAddress.name)
            }
            if (transaction.address && transaction.address.name && transaction.address.name !== '') {
                setName(transaction.address.name)
            }
            if (transaction.address && transaction.address.name && transaction.address.name !== '') {
                setName(transaction.address.name)
            }
            if (transaction.address && transaction.address.email && transaction.address.email !== '') {
                setEmail(transaction.address.email)
            }
            if (transaction.billingAddress && transaction.billingAddress.email && transaction.billingAddress.email !== '') {
                setEmail(transaction.billingAddress.email)
            }
            if (transaction.address && transaction.address.email && transaction.address.email !== '') {
                setEmail(transaction.address.email)
            }
            if (transaction.status) {
                setSelectedStatus(transaction.status);
            }
        }
    }, [transaction])

    useEffect(() => {
        dispatch(resetUpdateTransaction());
        const uuid = transaction.userId;
        if (uuid) {
            dispatch(getFirebaseInfo(uuid))
        }
    }, [])

    useEffect(() => {
        if (updateTransactionStatus !== "loading") {
            setLoadingStatus(null)
        }
    }, [updateTransactionStatus])

    useEffect(() => {
        if (transaction.price == '0.00') {
            setPriceString("Free")
        }
        else (
            setPriceString('€' + transaction.price)
        )
    })

    const renderButton = (status) => {
        const statusMap = {
            complete: { label: 'Complete Order', variant: 'outline-success' },
            approved: { label: 'Approve Order', variant: 'outline-secondary' },
            cancelled: { label: 'Reject Order', variant: 'danger' }
        };

        const { label, variant } = statusMap[status];

        return (
            <Button
                style={{ width: Spacing.SCALE_130 }}
                variant={variant}
                onClick={() => updateHandler(status)}
                disabled={loadingStatus === status}
            >
                {loadingStatus === status ? <CustomSpinner /> : label}
            </Button>
        );
    };


    return (
        <NewScreen>
            <Row style={{ marginBottom: Spacing.SCALE_300 }}>

                <Row>
                    <Col>
                        <CustomTitle subtitle={"Transaction Information"} description={`Review information and take action for order.`} />
                    </Col>
                </Row>

                {/* change status */}
                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Status</Form.Label>
                <Form.Select
                    aria-label="Update Order Status"
                    style={{ width: "31%" }}
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    disabled={!isEditingStatus}
                >
                    <option value="">Update Order Status</option>
                    <option value="complete">Complete Order</option>
                    <option value="approved">Approve Order</option>
                    <option value="cancelled">Reject Order</option>
                </Form.Select>

                <Row className="mt-3">
                    <Col className="p-1">
                        {!isEditingStatus ? (
                            <Button
                                variant="outline-primary"
                                onClick={() => setIsEditingStatus(true)}
                                style={{ width: "31%" }}
                            >
                                Edit
                            </Button>
                        ) : (
                            <div className="d-flex gap-2">
                                <Button
                                    variant="outline-success"
                                    onClick={() => {
                                        handleChangeField(selectedStatus);
                                        setIsEditingStatus(false);
                                    }}
                                    disabled={!selectedStatus || updateTransactionStatus === "loading"}
                                    style={{ width: "15%" }}
                                >
                                    {updateTransactionStatus === "loading" ? <CustomSpinner /> : "Save"}
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    onClick={() => {
                                        setSelectedStatus(transaction.status);
                                        setIsEditingStatus(false);
                                    }}
                                    style={{ width: "15%" }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        )}
                    </Col>
                </Row>


                <hr style={{ color: Colors.GRAY_DARK, border: 'none', borderTop: '1px solid #ccc', marginTop: 40, marginBottom: 40 }} />

                {/* sale information */}
                <Form.Label style={{ color: Colors.GRAY_DARK }}>Sale Information</Form.Label>
                <Row>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Order Date</Form.Label>
                        <Form.Control type="text" value={transaction.dateSoldString ? moment(transaction.dateSoldString).format("DD/MM/YY hh:mm A") : ""} readOnly />
                    </Col>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Total Cost</Form.Label>
                        <Form.Control type="text" value={transaction.price ? priceString : ""} readOnly />
                    </Col>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Distribution</Form.Label>
                        <Form.Control type="text" value={transaction.selectedDistribution ? transaction.selectedDistribution.charAt(0).toUpperCase() + transaction.selectedDistribution.slice(1) : ""} readOnly />
                    </Col>

                </Row>

                <hr style={{ color: Colors.GRAY_DARK, border: 'none', borderTop: '1px solid #ccc', marginTop: 40, marginBottom: 40 }} />

                {/* order information */}
                <Form.Label style={{ color: Colors.GRAY_DARK }}>Order Information</Form.Label>
                <Row>
                    {
                        transaction.productIds?.map((product, index) => {
                            return (
                                <Row>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Product</Form.Label>
                                        <Form.Control type="text" value={product.id ? product.id : ""} readOnly />
                                    </Col>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Quantity Ordered</Form.Label>
                                        <Form.Control type="text" value={product.quantity ? product.quantity : ""} readOnly />
                                    </Col>
                                    <Col />
                                </Row>
                            )
                        })
                    }
                </Row>

                <hr style={{ color: Colors.GRAY_DARK, border: 'none', borderTop: '1px solid #ccc', marginTop: 40, marginBottom: 40 }} />

                {/* customer information */}
                <Form.Label style={{ color: Colors.GRAY_DARK }}>Customer Information</Form.Label>
                <Row className="align-items-center">
                    <Col xs="auto">
                        <FaUserCircle
                            size={50}
                            onClick={() => showProfile()}
                            color={Colors.GRAY_DARK}
                            style={{ cursor: 'pointer', marginRight: 10, marginTop: Spacing.SCALE_24 }}
                        />
                    </Col>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Name</Form.Label>
                        <Form.Control type="text" value={name} readOnly />
                    </Col>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 10 }}>Email</Form.Label>
                        <Form.Control type="text" value={email} readOnly />
                    </Col>
                </Row>

                <hr style={{ color: Colors.GRAY_DARK, border: 'none', borderTop: '1px solid #ccc', marginTop: 40, marginBottom: 40 }} />

                {/* address information */}
                <Form.Label style={{ color: Colors.GRAY_DARK }}>Billing Address Information</Form.Label>
                <Row>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Address Line 1</Form.Label>
                        <Form.Control type="text" value={transaction.billingAddress && transaction.billingAddress.line1 ? transaction.billingAddress.line1 : ""} readOnly />
                    </Col>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>City</Form.Label>
                        <Form.Control type="text" value={transaction.billingAddress && transaction.billingAddress.city ? transaction.billingAddress.city : ""} readOnly />
                    </Col>
                    {transaction?.billingAddress?.country === 'Ireland' && (
                        <Col>
                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>County</Form.Label>
                            <Form.Control
                                type="text"
                                value={transaction?.billingAddress?.county || ""}
                                readOnly
                            />
                        </Col>
                    )}
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Country</Form.Label>
                        <Form.Control type="text" value={transaction.billingAddress && transaction.billingAddress.country ? transaction.billingAddress.country : ""} readOnly />
                    </Col>
                    <Col>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Post Code</Form.Label>
                        <Form.Control type="text" value={transaction.billingAddress && transaction.billingAddress.postal_code ? transaction.billingAddress.postal_code : ""} readOnly />
                    </Col>
                </Row>

                {/* delivery address information */}
                {transaction?.selectedDistribution != 'pickup' &&
                    <>

                        <hr style={{ color: Colors.GRAY_DARK, border: 'none', borderTop: '1px solid #ccc', marginTop: 40, marginBottom: 40 }} />

                        <Form.Label style={{ color: Colors.GRAY_DARK }}>Delivery Address Information</Form.Label>
                        <Row className="mb-5">
                            <Col>
                                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Address Line 1</Form.Label>
                                <Form.Control type="text" value={transaction.address && transaction.deliveryAddress.line1 ? transaction.deliveryAddress.line1 : ""} readOnly />
                            </Col>
                            <Col>
                                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>City</Form.Label>
                                <Form.Control type="text" value={transaction.address && transaction.deliveryAddress.city ? transaction.deliveryAddress.city : ""} readOnly />
                            </Col>
                            {transaction?.deliveryAddress?.country === 'Ireland' && (
                                <Col>
                                    <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>County</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={transaction?.deliveryAddress?.county || ""}
                                        readOnly
                                    />
                                </Col>
                            )}
                            <Col>
                                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Country</Form.Label>
                                <Form.Control type="text" value={transaction.address && transaction.deliveryAddress.country ? transaction.deliveryAddress.country : ""} readOnly />
                            </Col>
                            <Col>
                                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Post Code</Form.Label>
                                <Form.Control type="text" value={transaction.address && transaction.deliveryAddress.postal_code ? transaction.deliveryAddress.postal_code : ""} readOnly />
                            </Col>
                        </Row>
                    </>
                }

                {/* booking information */}
                {transaction?.selectedOrderBooking && (
                    <>
                        <hr style={{ color: Colors.GRAY_DARK, border: 'none', borderTop: '1px solid #ccc', marginTop: 40, marginBottom: 40 }} />
                        <Form.Label style={{ color: Colors.GRAY_DARK }}>Booking Information</Form.Label>
                        <Row>
                            <Col>
                                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Flight</Form.Label>
                                <Form.Control type="text" value={transaction?.selectedOrderBooking?.flightDetails?.carrierCode + transaction?.selectedOrderBooking?.flightDetails?.flightNumber} readOnly />
                            </Col>
                            <Col>
                                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 6 }}>Departure Date</Form.Label>
                                <Form.Control type="text" value={transaction?.selectedOrderBooking?.flightDetails?.departureDate} readOnly />
                            </Col>
                        </Row>
                    </>
                )}

            </Row>
        </NewScreen>
    );
};

export default TransactionInformation;
